
export const BASE_URL = "https://api.tocahealth.com";
export const BASE_URL_ML = "https://ai.tocahealth.com";
export const FRONTEND_BASE_URL = "https://login.tocahealth.com";

export const tenoviDevices = [
  {
    id: 1,
    label: "Bariatric Scale",
    value: "Bariatric Scale",
    type: "gateway",
    sensor_code: "13",
  },
  {
    id: 2,
    label: "Tenovi BPM - L",
    value: "Tenovi BPM - L",
    type: "gateway",
    sensor_code: "10",
  },
  {
    id: 3,
    label: "Tenovi BPM - S",
    value: "Tenovi BPM - S",
    type: "gateway",
    sensor_code: "10",
  },
  {
    id: 4,
    label: "Tenovi Cellular BPM - L",
    value: "Tenovi Cellular BPM - L",
    type: "cellular",
    sensor_code: "",
  },
  {
    id: 5,
    label: "Tenovi Cellular BPM - S",
    value: "Tenovi Cellular BPM - S",
    type: "cellular",
    sensor_code: "",
  },
  {
    id: 6,
    label: "Tenovi Cellular Glucometer",
    value: "Tenovi Cellular Glucometer",
    type: "cellular",
    sensor_code: "",
  },
  {
    id: 7,
    label: "Tenovi Cellular Pulse Ox",
    value: "Tenovi Cellular Pulse Ox",
    type: "cellular",
    sensor_code: "",
  },
  {
    id: 8,
    label: "Tenovi Cellular Scale",
    value: "Tenovi Cellular Scale",
    type: "cellular",
    sensor_code: "",
  },
  {
    id: 9,
    label: "Tenovi Glucometer",
    value: "Tenovi Glucometer",
    type: "gateway",
    sensor_code: "12",
  },
  {
    id: 10,
    label: "Tenovi Peak Flow Meter",
    value: "Tenovi Peak Flow Meter",
    type: "gateway",
    sensor_code: "17",
  },
  {
    id: 11,
    label: "Tenovi Pulse Ox",
    value: "Tenovi Pulse Ox",
    type: "gateway",
    sensor_code: "11",
  },
  {
    id: 12,
    label: "Tenovi Scale",
    value: "Tenovi Scale",
    type: "gateway",
    sensor_code: "13",
  },
  {
    id: 13,
    label: "Tenovi Thermometer",
    value: "Tenovi Thermometer",
    type: "gateway",
    sensor_code: "14",
  },
  {
    id: 14,
    label: "Tenovi Watch",
    value: "Tenovi Watch",
    type: "gateway",
    sensor_code: "15",
  },
  {
    id: 15,
    label: "Tenovi Hub",
    value: "Tenovi Hub",
    type: "hub",
    sensor_code: null,
  },
  {
    id: 16,
    label: "Omron Wrist BPM - 7 Series",
    value: "Omron Wrist BPM - 7 Series",
    type: "gateway",
    sensor_code: "10",
  },
];


export const deviceTypes = [
  {
    name: "Multiple Devices",
    id: 1,
  },
  {
    name: "Heart Rate Monitor",
    id: 2,
  },
];

export const deviceStatus = [
  {
    id: 1,
    label: "Pending delivery",
    value: "pending_delivery",
  },
  {
    id: 2,
    label: "Pending refurbishment",
    value: "pending_refurbishment",
  },
  {
    id: 3,
    label: "Pending warranty",
    value: "pending_warranty",
  },
  {
    id: 4,
    label: "Refurbished",
    value: "refurbished",
  },
  {
    id: 1,
    label: "Flag",
    value: "flag",
  },
];

export const states = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const timeZones = [
  { label: "Pacific Time (US & Canada)", value: "America/Los_Angeles" },
  { label: "Mountain Time (US & Canada)", value: "America/Denver" },
  { label: "Central Time (US & Canada)", value: "America/Chicago" },
  { label: "Eastern Time (US & Canada)", value: "America/New_York" },
  { label: "UTC", value: "UTC" },
];

export const months = [
  { label: "January", value: "01" },
  { label: "February", value: "02" },
  { label: "March", value: "03" },
  { label: "April", value: "04" },
  { label: "May", value: "05" },
  { label: "June", value: "06" },
  { label: "July", value: "07" },
  { label: "August", value: "08" },
  { label: "September", value: "09" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

export const generateYears = (startYear = 1900) => {
  const currentYear = new Date().getFullYear();
  if (typeof startYear !== "number" || startYear > currentYear) return [];
  return Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  );
};

export const ADMIN_YOUTUBE_EMAILS = [
  // "siam.cheema@neurooceans.ai",
  // "umair.saeed@neurooceans.ai",
  "m.fahid@tocahealth.com",
  // "D.gaur@tocahealth.com",
  // "d.gandhi@tocahealth.com",
].map((e) => e.toLowerCase());
